import type { CdmRootLocationFeatureToggles } from '../features/app-config/cdm-types';

import type { CdmLandingPagePathProps } from './types';

export const getIsOverviewPageEnabled = (
  rootLocationFeatureToggles: CdmRootLocationFeatureToggles | undefined
) =>
  Boolean(
    rootLocationFeatureToggles?.templateChecklistFlow ||
      rootLocationFeatureToggles?.workorderChecklistFlow
  );
export const getIsChecklistPageEnabled = (
  rootLocationFeatureToggles: CdmRootLocationFeatureToggles | undefined
) =>
  Boolean(
    rootLocationFeatureToggles?.templateChecklistFlow ||
      rootLocationFeatureToggles?.workorderChecklistFlow
  );

export const getIsTemplatesPageEnabled = (
  rootLocationFeatureToggles: CdmRootLocationFeatureToggles | undefined
) => Boolean(rootLocationFeatureToggles?.templateChecklistFlow);

export const getIsObservationsPageEnabled = (
  rootLocationFeatureToggles: CdmRootLocationFeatureToggles | undefined
): boolean => Boolean(rootLocationFeatureToggles?.observations);

export const getIsObservationsFeatureEnabledOnIdm = (
  isObservationsFeatureIdmFeatureFlagEnabled: boolean,
  rootLocationFeatureToggles: CdmRootLocationFeatureToggles | undefined
): boolean =>
  isObservationsFeatureIdmFeatureFlagEnabled || // The feature flag can be removed once users migrate to cdm
  getIsObservationsPageEnabled(rootLocationFeatureToggles);

export const getRootContainer = () => document.getElementById('root');

export const getLandingPagePath = ({
  isDailyBriefEnabled,
  hasUserEnabledAtlasHome,
  isChecklistPageEnabled,
  isDesktop,
  isObservationsFeatureEnabledOnIdm,
  selectedRootLocation,
}: CdmLandingPagePathProps): string => {
  // /explore is the mobile home page, so desktop keeps its landing page until a desktop home exists.
  if (isDailyBriefEnabled && hasUserEnabledAtlasHome && !isDesktop) {
    return '/explore';
  }

  if (isChecklistPageEnabled) {
    return '/checklists';
  }

  if (isDesktop && isObservationsFeatureEnabledOnIdm) {
    return '/observations';
  }

  if (isDesktop && selectedRootLocation) {
    return `/asset/${selectedRootLocation.assetExternalId}`;
  }

  return '/explore';
};
